import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 145.99 118.58"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M108.35 90.98c-.7 0-1.41.06-2.3.31-10.66 3.19-49.45 16.47-95.14 22.83-2.04.27-1.51 1.23.92 1.38 30.53 2.89 42.08 3.2 56.07 3.06 13.42-.44 23.48 1.43 34.78-10.57 10.39-10.75 10.56-16.95 5.67-17Z",
      style: {"fill":"#c52528"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M1.48 112.26c31.22-7.95 109.39-49.95 120.99-57.42 5.72-3.56 12.04-1.45 1.95 15.01-6.88 10.11-11.61 15.99-29.97 21.56-12.61 4.77-59.42 18.4-92.2 22.35-2.43.2-3.2-.69-.78-1.5",
      style: {"fill":"#ffc92d"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M4.59 110.06c27.24-9.56 86.57-40.79 106.79-53.2 14.55-8.85 25.81-15.4 30.19-26.5C150.96 5 143.78-5.32 134.85 2.6 123.47 13.69 69.81 69.96 1.18 109.51c-1.04.59-1.17 1.97 3.42.55",
      style: {"fill":"#5e8f4d"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "ET-logo"}) } }